export const RESOURCE_STATUS = {
  RASCUNHO: "RASCUNHO",
  ENVIADO: "ENVIADO",
  EM_ANALISE: "EM_ANALISE",
  GESTAO_NACIONAL: "GESTAO_NACIONAL",
  COMPLEMENTAR: "COMPLEMENTAR",
  DEFERIDO: "DEFERIDO",
  INDEFERIDO: "INDEFERIDO",
  CANCELADO: "CANCELADO",
};

export const RESOURCE_STATUSES = [
  {
    value: RESOURCE_STATUS.RASCUNHO,
    text: "Rascunho",
    color: "grey",
  },
  {
    value: RESOURCE_STATUS.ENVIADO,
    text: "Enviado",
    color: "primary",
  },
  {
    value: RESOURCE_STATUS.EM_ANALISE,
    text: "Em análise",
    color: "warning",
  },
  {
    value: RESOURCE_STATUS.GESTAO_NACIONAL,
    text: "Gestão Nacional",
    color: "deep-purple",
  },
  {
    value: RESOURCE_STATUS.COMPLEMENTAR,
    text: "Complementar",
    color: "orange",
  },
  {
    value: RESOURCE_STATUS.DEFERIDO,
    text: "Deferido",
    color: "success",
  },
  {
    value: RESOURCE_STATUS.INDEFERIDO,
    text: "Indeferido",
    color: "error",
  },
  {
    value: RESOURCE_STATUS.CANCELADO,
    text: "Cancelado",
    color: "grey darken-1",
  },
];

export const DEFAULT_STATUS_ORDER = RESOURCE_STATUSES.map((status) => status.value);

export const findStatusMeta = (status) =>
  RESOURCE_STATUSES.find((item) => item.value === status) || {
    value: status,
    text: status,
    color: "grey",
  };

const normalizeStatusValue = (status) => {
  if (status === null || status === undefined) {
    return "";
  }

  return String(status).trim().toUpperCase();
};

export const normalizeResourceStatus = (status) => {
  const normalized = normalizeStatusValue(status);

  if (!normalized) {
    return normalized;
  }

  if (normalized === RESOURCE_STATUS.GESTAO_NACIONAL) {
    return RESOURCE_STATUS.EM_ANALISE;
  }

  if (normalized === RESOURCE_STATUS.ENVIADO) {
    return RESOURCE_STATUS.EM_ANALISE;
  }

  return normalized;
};

export const isResourceStatusGestaoNacional = (status) =>
  normalizeStatusValue(status) === RESOURCE_STATUS.GESTAO_NACIONAL;

